import React from "react";
import { toAbsoluteUrl } from "../../../_metronic";
import "../../../_metronic/_assets/sass/pages/error/error-4.scss";
import translate from '@noar-health/commons';
import { useSelector } from 'react-redux';

export default function ErrorPage() {
  const locale = useSelector(({ i18n }) => i18n.lang);
  return (
    <>
      <div className="kt-grid kt-grid--ver kt-grid--root">
        <div
          className="kt-grid__item kt-grid__item--fluid kt-grid kt-error-v4"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("/media//error/bg4.jpg")})`
          }}
        >
          <div className="kt-error_container">
            <h1 className="kt-error_number">404</h1>
            <p className="kt-error_title">
              {translate(locale).defaultMessages.error}
            </p>
            <p className="kt-error_description">
              {translate(locale).defaultMessages.nothingHere}
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
